// src/components/ScrollToTop.jsx
import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function ScrollToTop({ behavior = "auto" }) {
  const { pathname, hash, key } = useLocation()

  useEffect(() => {
    // If the route has a hash, let the browser handle anchor jump after paint
    if (hash) {
      // small timeout to ensure the target exists
      const id = setTimeout(() => {
        const el = document.querySelector(hash)
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" })
      }, 0)
      return () => clearTimeout(id)
    }

    // No hash. Scroll to page top on pathname change
    window.scrollTo({ top: 0, left: 0, behavior })
  }, [pathname, hash, key, behavior])

  return null
}
